import { 
  ROUTER_AGGR_STATS_API_LOADING,
  SAVE_ROUTER_AGGR_STATS_GRAPH
 } from "../../constants/graphConstants/connectedClientsGraphConstants";

 export const routerAggStatsReducer = (state = { aggrStats: {}, loading: false, routerAggStatsError: null },action) => {
    switch (action.type) {
        case ROUTER_AGGR_STATS_API_LOADING:
          return {
            ...state,
            aggrStats: {},
            loading: action.payload,
            routerAggStatsError: null,
          };
        case SAVE_ROUTER_AGGR_STATS_GRAPH:
          return {
            ...state,
            loading: false,
            ...action.payload,
          };
        default:
          return state;
      }
 }